export const DEFAULT_EDITOR_ORIGIN = 'https://stackblitz.com';
export const SEARCH_PARAM_AUTH_CODE = 'code';
export const SEARCH_PARAM_ERROR = 'error';
export const SEARCH_PARAM_ERROR_DESCRIPTION = 'error_description';
export const BROADCAST_CHANNEL_NAME = '__wc_api_bc__';
export const STORAGE_TOKENS_NAME = '__wc_api_tokens__';
export const STORAGE_CODE_VERIFIER_NAME = '__wc_api_verifier__';
export const STORAGE_POPUP_NAME = '__wc_api_popup__';
